import { css, StyleDeclarationValue } from 'aphrodite';
import { ReactNode } from 'react';
import { Skeleton } from '../../../../components-v2/Skeleton';
import { styleSheet } from './styles';

type Props = {
	title: ReactNode;
	data: string | number;
	/** A short line under the value, such as the change over a period. */
	caption?: ReactNode;
	loading?: boolean;
	styles?: StyleDeclarationValue[];
	className?: string;
};

export const DataDisplay = ({ title, data, caption, loading, styles, className }: Props) => {
	if (loading) {
		return (
			<div className={className || ''}>
				<Skeleton styles={[styleSheet.dataDisplay, ...(styles || [])]}>
					<h1 className={css(styleSheet.title)}>Loading...</h1>
					<p className={css(styleSheet.data)} />
				</Skeleton>
			</div>
		);
	}

	return (
		<div className={`${css(styleSheet.dataDisplay, ...(styles || []))} ${className || ''}`}>
			<h1 className={css(styleSheet.title)}>{title}</h1>
			<p className={css(styleSheet.data)}>{data}</p>
			{caption ? <p className={css(styleSheet.caption)}>{caption}</p> : null}
		</div>
	);
};
